import React from "react";
import { Link, NavLink } from "react-router-dom";

const tabs = [
  {
    type: "tab",
    to: "/seller",
    label: "Home",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4",
  },
  {
    type: "tab",
    to: "/seller/deliveries",
    label: "Deliveries",
    icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
  },
  {
    type: "fab",
    to: "/seller/new-order",
    label: "Request Delivery",
  },
  {
    type: "tab",
    to: "/seller/account",
    label: "Account",
    icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
  },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white dark:bg-zinc-900 border-t border-gray-100 dark:border-zinc-800 grid grid-cols-4 safe-area-pb z-30 transition-colors"
      style={{ boxShadow: "0 -1px 12px 0 rgba(0,0,0,0.07)" }}
    >
      {tabs.map((t) =>
        t.type === "fab" ? (
          /* ── Centre FAB slot ── */
          <div
            key={t.to}
            className="relative flex flex-col items-center justify-center py-1"
          >
            {/* Pill-shaped elevated button */}
            <Link
              to={t.to}
              aria-label={t.label}
              className="flex items-center gap-1.5 px-4 py-2.5 rounded-2xl bg-emerald-500 text-white active:scale-95 transition-transform"
              style={{ boxShadow: "0 4px 18px 0 rgba(16,185,129,0.45)" }}
            >
              <svg
                className="w-4 h-4 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4v16m8-8H4"
                />
              </svg>
              <span className="text-xs font-semibold tracking-wide">New</span>
            </Link>
          </div>
        ) : (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/seller"}
            className={({ isActive }) =>
              `flex flex-col items-center py-2 text-xs ${
                isActive
                  ? "text-emerald-600 dark:text-emerald-400"
                  : "text-gray-400 dark:text-gray-500"
              }`
            }
          >
            <svg
              className="w-6 h-6 mb-0.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d={t.icon} />
            </svg>
            {t.label}
          </NavLink>
        ),
      )}
    </nav>
  );
}
